<template>
  <div class="main-class">
    <h2>INTEGRANTES</h2>
    <TabelaEquipe class="tabela" />
  </div>
</template>

<style lang="scss" scoped>
h2 {
  font-weight: bold;
  font-size: 46px;
  margin-top: 3rem;
}
.tabela {
  margin-top: -1.5rem !important;
  margin-left: -2rem;
}
@media (max-width: 1024px) {
  .main-class {
    margin-left: 8rem;
  }
}
@media (max-width: 770px) {
  h2 {
    font-size: 42px;
  }
}
@media (max-width: 540px) {
  .main-class {
    margin-left: 0;
  }
  .tabela {
    margin-left: 0rem;
    margin-top: 1rem !important;
  }
  h2 {
    margin-top: 1rem !important;
    font-size: 30px;
    margin-left: 5rem;
  }
}
@media (max-width: 540px) and (min-width: 540px) {
  .tabela {
    margin-left: 2rem;
    margin-right: 2rem !important;
  }
  h2 {
    margin-left: 7rem !important;
  }
}
@media (max-width: 280px) and (min-width: 280px) {
  h2 {
    font-size: 1.5rem;
  }
}
@media (max-width: 360px) and (min-width: 360px) {
  h2 {
    margin-top: 0.3rem !important;
  }
  .tabela {
    margin-top: 0rem !important;
  }
}
</style>

<script>
import TabelaEquipe from '@/components/dashboard/TabelaEquipe.vue';

import backUrl from '@/utils/backUrl.js';
import { seo } from '@/utils/seo.js';

export default {
  name: 'Team',
  components: { TabelaEquipe },
  metaInfo() {
    return seo(
      'Integrantes',
      'Integrantes - Site do Projeto Niara',
      `${this.backUrl}/download-file/logo/ProjetoNiaraLogo.png`,
      this.thisUrl,
      'website',
      ' - Dashboard Projeto Niara',
    );
  },
  data() {
    return {
      thisUrl: window.location.href,
      backUrl: backUrl,
    };
  },
};
</script>
